export default { navigationWireToInt };

function navigationWireToInt (wireNavigation) {
  if (!wireNavigation || !wireNavigation.navbuttons || !wireNavigation.navbuttons.navbuttons) {
    return [];
  }

  let navigation = wireNavigation.navbuttons.navbuttons || [];
  let intNavigation = [];

  for (let i = 0; i < navigation.length; i++) {
    const { id, selectable } = navigation[ i ]._attributes;
    intNavigation.push({
      id: id,
      enabled: selectable && selectable === 'true',
    });
  }

  return intNavigation;
}



// WEBPACK FOOTER //
// ./src/converter/NavigationConverter.js